export const ROUTE_BASE_NAME = "billing";

export const ROUTE_NAMES = {
  BillingMain: `${ROUTE_BASE_NAME}`,
};
